export default __webpack_public_path__ + "static/LandPilot-5c493bc8b8ed96ce070381905335252b.png";